export default {
  title: 'Raport jakości',
};
